import { defineStore } from 'pinia'

import state from './state.js'
import actions from './actions.js'

const useRolesStore = defineStore('surveys', {
  state,
  actions
})

export default useRolesStore
